import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Multiseaterbuses() {



  const cardData = {
"keyword": "14, 17, 20, and 25-Seater Bus Rental in Pune",

"headingDescription":
  "Aaradhya Travels offers reliable 14, 17, 20, and 25-Seater Bus Rental in Pune for family trips, corporate travel, weddings, school and college outings, airport transfers, and outstation group journeys. Our mini and mid-size buses are well-maintained and equipped with air-conditioning, comfortable pushback seats, spacious interiors, luggage space, and experienced drivers familiar with Pune city and highway routes. We ensure safe, comfortable, and punctual group transportation with doorstep pickup from all major areas of Pune, suitable for both local and long-distance travel requirements.",

"topPlaces": [
{
"title": "Dapoli",
"description":
"Dapoli is a peaceful coastal destination known for clean beaches, dolphin spotting, and calm surroundings. It is ideal for family and group tours from Pune using 32 seater buses."
},
{
"title": "Murud-Janjira",
"description":
"Murud-Janjira is famous for its sea fort located on an island, attracting history lovers and tourists. It is a popular coastal sightseeing destination for group tours from Pune."
},
{
"title": "Tamhini Ghat",
"description":
"Tamhini Ghat is a scenic monsoon destination known for waterfalls, foggy mountains, and lush greenery. It is one of the most popular short road trips from Pune for group travel."
},
{
"title": "Pawna Lake",
"description":
"Pawna Lake is a popular camping and weekend getaway spot near Lonavala known for lakeside tents, bonfires, and sunset views. It is widely chosen for group camping trips from Pune."
},
{
"title": "Shani Shingnapur",
"description":
"Shani Shingnapur is a famous pilgrimage village known for the Shani Temple where Lord Shani is worshipped. It is a highly visited spiritual destination from Pune, often preferred by group travelers using 32 seater buses for comfortable temple darshan and religious tours."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a beautiful hill station known for Arthur Lake, Randha Falls, and lush green valleys. It is a peaceful weekend getaway from Pune, popular for group tours and nature trips using 32 seater buses."
},
{
"title": "Kaas Plateau",
"description":
"Kaas Plateau, also called the Valley of Flowers of Maharashtra, is a UNESCO World Heritage site famous for seasonal wildflowers and biodiversity. It is a popular monsoon tourism destination for group travel from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a scenic hill station in the Sahyadri range known for waterfalls, misty valleys, and monsoon beauty. It is widely chosen for long group trips and nature tours from Pune using 32 seater buses."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular stop for long-distance group travel and leisure tours from Pune."
},
{
"title": "Ratnagiri",
"description":
"Ratnagiri is a coastal Konkan destination known for beaches, forts, Alphonso mangoes, and long scenic road trips. It is a popular long-distance group travel destination from Pune."
}
],



services: [
  {
    name: "14 Seater Bus Pune",
    description: "14 seater bus Pune service provides comfortable transportation for family vacations, airport transfers, sightseeing tours, office travel, and small group journeys. Spacious seating and luggage space ensure smooth travel suitable for local and outstation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient 14 seater bus reservations."
  },
  {
    name: "17 Seater Bus Pune",
    description: "17 seater bus Pune service offers spacious transportation for family outings, business travel, tourist groups, and airport pickup services. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Flexible booking options allow convenient 17 seater bus reservations."
  },
  {
    name: "20 Seater Bus Pune",
    description: "20 seater bus Pune service provides reliable transportation for corporate outings, sightseeing tours, wedding functions, airport transfers, and group travel requirements. Spacious seating and luggage capacity ensure comfortable journeys suitable for local and outstation travel. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient 20 seater bus reservations."
  },
  {
    name: "25 Seater Bus Pune",
    description: "25 seater bus Pune service provides spacious transportation for educational tours, office travel, family vacations, wedding groups, and sightseeing trips. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, and airports across Pune. Flexible booking options allow convenient 25 seater bus reservations."
  },
  {
    name: "Small Bus Hire Pune",
    description: "Small bus hire Pune service offers dependable transportation for family outings, school trips, corporate travel, sightseeing journeys, and local or outstation group travel. Spacious seating ensures smooth travel suitable for small and medium-sized passenger groups. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient small bus hire reservations."
  },
  {
    name: "Mini Bus Rental Pune",
    description: "Mini bus rental Pune service provides affordable and comfortable transportation for office outings, wedding travel, airport transfers, tourist trips, and family journeys. Spacious interiors ensure smooth travel suitable for local and outstation transportation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient mini bus rental reservations."
  },
  {
    name: "Pune to Shirdi Small Bus",
    description: "Pune to Shirdi small bus service provides comfortable transportation for pilgrimage tours, Sai Baba temple visits, family trips, and religious group travel. Spacious seating and smooth highway travel ensure pleasant journeys suitable for long-distance temple tours. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Shirdi small bus reservations."
  },
  {
    name: "Pune to Mahabaleshwar Mini Bus",
    description: "Pune to Mahabaleshwar mini bus service offers reliable transportation for hill station vacations, sightseeing tours, weekend trips, and family outings. Comfortable seating and smooth ghat road travel ensure enjoyable journeys suitable for group travel. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Mahabaleshwar mini bus reservations."
  },
  {
    name: "Wedding Small Bus Pune",
    description: "Wedding small bus Pune service offers stylish transportation for marriage ceremonies, bridal parties, wedding guests, and family travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding celebrations and event transportation. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pune. Flexible booking options allow convenient wedding small bus reservations."
  },
  {
    name: "Corporate Small Bus Pune",
    description: "Corporate small bus Pune service provides professional transportation for office staff, conferences, business meetings, corporate outings, and employee travel requirements. Comfortable seating ensures smooth journeys suitable for executive passengers and office teams. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from offices, commercial hubs, hotels, and business locations across Pune. Flexible booking options allow convenient corporate small bus reservations."
  },
  {
    name: "Airport Pickup Small Bus Pune",
    description: "Airport pickup small bus Pune service provides dependable transportation for airport transfers, tourist groups, business travelers, and family travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation airport transportation. Professional chauffeurs ensure timely airport pickups and safe driving services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient airport pickup small bus reservations."
  },
  {
    name: "Family Trip Small Bus Pune",
    description: "Family trip small bus Pune service offers dependable transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Spacious seating and comfortable interiors ensure pleasant journeys suitable for local and outstation family group travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient family trip small bus reservations."
  },
  {
    name: "Group Travel Small Bus Pune",
    description: "Group travel small bus Pune service provides spacious transportation for educational tours, sightseeing journeys, office outings, family vacations, and tourist travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient group travel small bus reservations."
  },
  {
    name: "Hinjewadi Small Bus Pune",
    description: "Hinjewadi small bus Pune service provides dependable transportation for IT employees, office commute, business meetings, and employee shuttle travel requirements. Comfortable seating ensures smooth journeys suitable for office staff and corporate passenger groups. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and business hubs across Hinjewadi Pune. Flexible booking options allow convenient Hinjewadi small bus reservations."
  },
  {
    name: "Kharadi Small Bus Pune",
    description: "Kharadi small bus Pune service offers reliable transportation for corporate travel, office outings, airport transfers, and group travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for IT employees and family groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial hubs across Kharadi Pune. Flexible booking options allow convenient Kharadi small bus reservations."
  },
  {
    name: "Baner Small Bus Pune",
    description: "Baner small bus Pune service provides comfortable transportation for family trips, office travel, airport pickups, and sightseeing journeys. Spacious seating and luggage space ensure smooth journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Baner Pune. Flexible booking options allow convenient Baner small bus reservations."
  },
  {
    name: "Wakad Small Bus Pune",
    description: "Wakad small bus Pune service provides reliable transportation for office commute, family outings, airport transfers, and outstation group travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for business and leisure travel requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Wakad Pune. Flexible booking options allow convenient Wakad small bus reservations."
  },
  {
    name: "Pimpri Chinchwad Small Bus Pune",
    description: "Pimpri Chinchwad small bus Pune service offers dependable transportation for corporate travel, family vacations, wedding functions, and airport transfers. Spacious seating and luggage capacity ensure smooth journeys suitable for local and outstation passenger movement. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient small bus reservations."
  },
  {
    name: "Pune Darshan Mini Bus",
    description: "Pune Darshan mini bus service offers dependable transportation for sightseeing tours, tourist visits, heritage travel, and family outings across Pune city attractions. Spacious seating ensures comfortable journeys suitable for local tourism and group travel requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the tour route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Pune Darshan mini bus reservations."
  },
  {
    name: "Outstation Small Bus Pune",
    description: "Outstation small bus Pune service provides dependable long-distance transportation for Goa tours, pilgrimage journeys, sightseeing trips, family vacations, and tourist travel. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient outstation small bus reservations."
  },
  {
    name: "Luxury Mini Bus Pune",
    description: "Luxury mini bus Pune service provides premium transportation with modern interiors and comfortable seating for weddings, corporate travel, airport transfers, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient luxury mini bus reservations."
  },
  {
    name: "AC Small Bus Pune",
    description: "AC small bus Pune service offers air-conditioned transportation for weddings, family outings, sightseeing tours, office travel, and outstation group journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient AC small bus reservations."
  },
  {
    name: "Budget Bus Pune",
    description: "Budget bus Pune service provides economical transportation for educational tours, office travel, sightseeing journeys, family outings, and local or outstation group trips. Spacious seating and luggage space ensure comfortable travel experiences suitable for budget-friendly transportation requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient budget bus reservations."
  },
  {
    name: "Event Transport Small Bus Pune",
    description: "Event transport small bus Pune service provides dependable transportation for corporate functions, concerts, exhibitions, weddings, conferences, and social gatherings. Spacious seating ensures smooth journeys suitable for local and outstation event travel requirements. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and event venues across Pune. Flexible booking options allow convenient event transport small bus reservations."
  },
  {
    name: "Weekend Trip Small Bus Pune",
    description: "Weekend trip small bus Pune service offers comfortable transportation for holiday getaways, hill station tours, sightseeing journeys, and family vacations. Spacious seating and smooth highway travel ensure pleasant travel experiences suitable for local and outstation weekend trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient weekend trip small bus reservations."
  },
  {
    name: "Tourist Mini Bus Pune",
    description: "Tourist mini bus Pune service provides dependable transportation for sightseeing tours, holiday vacations, family outings, and tourist travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation tourism activities. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient tourist mini bus reservations."
  }
],

tableData: [
  ["14 Seater Bus Pune", "17 Seater Bus Pune"],
  ["20 Seater Bus Pune", "25 Seater Bus Pune"],
  ["Small Bus Hire Pune", "Mini Bus Rental Pune"],
  ["Pune to Shirdi Small Bus", "Pune to Mahabaleshwar Mini Bus"],
  ["Wedding Small Bus Pune", "Corporate Small Bus Pune"],
  ["Airport Pickup Small Bus Pune", "Family Trip Small Bus Pune"],
  ["Group Travel Small Bus Pune", "Hinjewadi Small Bus Pune"],
  ["Kharadi Small Bus Pune", "Baner Small Bus Pune"],
  ["Wakad Small Bus Pune", "Pimpri Chinchwad Small Bus Pune"],
  ["Pune Darshan Mini Bus", "Outstation Small Bus Pune"],
  ["Luxury Mini Bus Pune", "AC Small Bus Pune"],
  ["Budget Bus Pune", "Event Transport Small Bus Pune"],
  ["Weekend Trip Small Bus Pune", "Tourist Mini Bus Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 14, 17, 20 & 25-Seater Bus Rental in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 14, 17, 20, and 25-seater bus rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for family trips, corporate tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable Mini Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 14, 17, 20, and 25-seater bus rental packages in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Bus Booking Service",
        WhyChoosedescription: "Our mini bus rental service in Pune operates 24 hours for airport transfers, weddings, outstation tours, pilgrimage trips, corporate outings, school tours, and holiday travel."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC Bus Options",
        WhyChoosedescription: "All 14, 17, 20, and 25-seater buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for comfortable group travel."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, pilgrimage journeys, sightseeing travel, and multi-day outstation packages according to customer requirements."
      },
      {
        WhyChooseheading: "Perfect for Family & Corporate Group Travel",
        WhyChoosedescription: "Our 14, 17, 20, and 25-seater buses are ideal for family vacations, office outings, wedding guest transport, school trips, picnic tours, and tourist group travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Pune Airport, railway stations, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Outstation Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What are 14, 17, 20, and 25-seater buses on rent in Pune?", answer: "These are mini bus rental services in Pune providing comfortable group transportation for family tours, corporate travel, weddings, and outstation journeys." },
    { question: "Is mini bus booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 booking service for 14, 17, 20, and 25-seater buses in Pune." },
    { question: "Are AC and Non-AC buses available?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC mini buses for comfortable and budget-friendly group travel." },
    { question: "Can I book mini buses for outstation trips?", answer: "Yes, customers can book mini buses for hill stations, pilgrimage tours, holiday trips, and outstation travel from Pune." },
    { question: "Do you provide buses for corporate events in Pune?", answer: "Yes, Aaradhya Travels provides mini bus rental services for office outings, conferences, employee transport, and corporate travel." },
    { question: "Can I book mini buses for weddings and school trips?", answer: "Yes, our 14, 17, 20, and 25-seater buses are ideal for wedding guest transportation, school excursions, and group travel." },
    { question: "Can I book mini buses online in Pune?", answer: "Yes, customers can easily book mini bus rental services online or through phone booking." },
    { question: "Do you provide Pune Airport pickup and drop service?", answer: "Yes, Aaradhya Travels provides airport pickup and drop service using mini buses." },
    { question: "Are mini bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for mini bus rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Dinesh Jagtap",
    feedback:
      "For our weekend trip, we arranged a 20-seater bus rental in Pune and the overall experience was very comfortable. The bus was clean, well-maintained, and perfectly suited for our group travel needs.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shraddha More",
    feedback:
      "A 20-seater bus in Pune helped us manage transportation for a family function smoothly. Everyone could travel together easily, and the journey remained pleasant and hassle-free.",
    rating: 5
  }
];
  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "14, 17, 20, and 25-Seater Bus Rental in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/small-bus-rental-pune.jpg",
  "description": "Book 14, 17, 20, and 25 seater buses on rent in Pune with Aaradhya Travels for corporate travel, weddings, airport transfers, family trips, group tours, and outstation journeys including Shirdi and Mahabaleshwar. Comfortable AC and non-AC mini buses available with driver.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "10240"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/small-bus-rental-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>
    14 to 25 Seater Bus Rental in Pune | Small Group Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 14, 17, 20, and 25 seater buses on rent in Pune with Aaradhya Travels. Ideal for weddings, corporate trips, airport pickup, family travel, and outstation tours to Shirdi, Mahabaleshwar, and Lonavala."
  />

  <meta
    name="keywords"
    content="14 seater bus Pune, 17 seater bus Pune, 20 seater bus Pune, 25 seater bus Pune, small bus hire Pune, mini bus rental Pune, Pune to Shirdi small bus, Pune to Mahabaleshwar mini bus, wedding small bus Pune, corporate small bus Pune, airport pickup small bus Pune, family trip small bus Pune, group travel bus Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/79.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Multiseaterbuses ;